import React from 'react';
const plans = ['free', 'business_trial', 'starter', 'pro', 'business', 'enterprise'];

export default function OpsPlanFilter({ value, onChange }) {
  return <div className="sm:w-48">
    <select aria-label="Effective plan filter" value={value} onChange={(event) => onChange(event.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      <option value="">All Plans</option>
      {plans.map((plan) => <option key={plan} value={plan}>
        {plan.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} Plan
      </option>)}
    </select>
  </div>;
}
